export class CaseSubscription {

	public id: string;

}